import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataTable} from "primereact/datatable";
import axios from "axios";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {Button} from "primereact/button";
import Spinner from "../../spinner/Spinner";


const Volumes = props => {
    const toast = useRef(null);
    const [volumes, setVolumes] = useState([]);
    const [loadingState, setLoadingState] = useState(false);


    useEffect(() => {
        getVolumes();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getVolumes = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-volume/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        ////console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setVolumes(data.volumes);
                            showSuccess("Mantıksal Sürücüler listelendi");
                        } else {
                            setLoadingState(false);
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const attachBody = (rowData) => {
        return (
            <React.Fragment>
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <span className="p-column-title">ATAMALAR</span>
                    </div>
                    <div className="p-col-12">
                        <div align='center' style={{wordBreak: 'break-all'}}>
                            {rowData.attached_to.length > 0
                                ?
                                <ul>
                                    {rowData.attached_to.map(attach => {
                                        return (
                                            <li>{attach}</li>
                                        );
                                    })}
                                </ul>
                                :
                                <span>-</span>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    const getVolumeBody = (compute_key, compute_name) => {
        const volumeBody = (rowData) => {
            return (
                <React.Fragment>
                    <div align="center">
                        <div className="p-grid">
                            <div className="p-col-12" align="center">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" align="center" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return volumeBody;
    }

    const processBody = (rowData) => {
        return (
            <React.Fragment>
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <span className="p-column-title">İŞLEVLER</span>
                    </div>
                    <div className="p-col-12" align="center">
                        <div className='p-grid'>
                            <div className="p-col-12">
                                <Button className='p-button-text p-button-warning' icon='pi pi-pencil'/>
                                <Button className='p-button-text p-button-danger' icon='pi pi-trash'/>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    const getHeader = (value) => {
        return (
            <div align="center" style={{wordBreak: 'break-all'}}>{value}</div>
        );
    }

    return (
        <div className='p-fluid'>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>
            <div className="datatable-responsive-demo">
                <div className='card'>
                    <DataTable
                        value={volumes} className='p-datatable-responsive-demo' paginator rows={10}
                        header={<h4><b>Kayıtlı Mantıksal Sürücüler</b></h4>}
                        emptyMessage="Kayıt Bulunamadı"
                    >
                        <Column field="name"
                                header={getHeader("MANTIKSAL SÜRÜCÜ ADI")}
                                body={getVolumeBody("name", "MANTIKSAL SÜRÜCÜ ADI")}/>
                        <Column field="description"
                                header={getHeader("AÇIKLAMA")}
                                body={getVolumeBody("description", "AÇIKLAMA")}/>
                        <Column field="size"
                                header={getHeader("BOYUT")}
                                body={getVolumeBody("size", "BOYUT")}/>
                        <Column field="status"
                                header={getHeader("DURUM")}
                                body={getVolumeBody("status", "DURUM")}/>
                        <Column field="type"
                                header={getHeader("TÜR")}
                                body={getVolumeBody("type", "TÜR")}/>
                        <Column field="attached_to"
                                header={getHeader("ATAMALAR")}
                                body={attachBody}/>
                        <Column field="bootable"
                                header={getHeader("BAŞLATILABİLİRLİK")}
                                body={getVolumeBody("bootable", "BAŞLATILABİLİRLİK")}/>
                        <Column field="encrypted"
                                header={getHeader("ŞİFRELİ")}
                                body={getVolumeBody("encrypted", "ŞİFRELİ")}/>
                        {/*<Column header={getHeader("İŞLEVLER")}
                                body={processBody}/>*/}
                    </DataTable>
                </div>
            </div>

        </div>
    );

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Volumes);


// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/Volumes.jsx